import {
  ChangeDetectorRef,
  Directive,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

import { catchError, first, firstValueFrom, map, throwError } from 'rxjs';

import { Store } from '@ngrx/store';

import { MasterFetchService } from '../../../fetches/services/master-fetch.service';
import { NgRxState } from '../../../modules/app-ngrx.module';
import { MasterAction } from '../../../stored/global/actions';

@Directive({
  selector: '[xbahtMasterMonthlyPayment]',
})
export class MonthlyPaymentDirective implements OnInit {
  constructor(
    private cd: ChangeDetectorRef,
    private ngrxStore: Store<NgRxState>,
    private templateRef: TemplateRef<{
      $implicit: {
        id: string;
        sequence: number;
        code: string;
        country: string;
        symbol: string;
        description: string;
        incomes?: { max: number; min: number }[] | null;
        sendings?: { max: number; min: number }[] | null;
      };
      index: number;
      first: boolean;
      last: boolean;
      even: boolean;
      odd: boolean;
      count: number;
    }>,
    private viewContainer: ViewContainerRef,
    private masterFetchService: MasterFetchService
  ) {}

  async ngOnInit(): Promise<void> {
    const monthly_payments = await firstValueFrom(
      this.ngrxStore.select('Master').pipe(map((item) => item.monthly_payments))
    );
    if (monthly_payments.length != 0) {
      for (let index = 0; index < monthly_payments.length; index++) {
        this.viewContainer.createEmbeddedView(this.templateRef, {
          $implicit: monthly_payments[index],
          index,
          first: index === 0,
          last: index === monthly_payments.length - 1,
          even: (index & 1) === 0,
          odd: (index & 1) === 1,
          count: monthly_payments.length,
        });
      }

      this.cd.detectChanges();
    } else {
      this.masterFetchService
        .monthlyPayment({})
        .pipe(
          first(),
          catchError((error) => throwError(() => error))
        )
        .subscribe((item) => {
          if (item.status && item.payload) {
            this.ngrxStore.dispatch(
              MasterAction.SetMonthlyPayment({ monthly_payments: item.payload })
            );

            this.viewContainer.clear();
            for (let index = 0; index < item.payload.length; index++) {
              this.viewContainer.createEmbeddedView(this.templateRef, {
                $implicit: item.payload[index],
                index,
                first: index === 0,
                last: index === item.payload.length - 1,
                even: (index & 1) === 0,
                odd: (index & 1) === 1,
                count: item.payload?.length,
              });
            }

            this.cd.detectChanges();
          }
        });
    }
  }
}
